// NOTE: THIS FILE IS AUTO GENERATED BY NPM SCRIPT!
import { env } from './env.production';
export default env;